import { gql } from '@apollo/client';

export const DEPLOY_NOTIFICATION_RECEIVED = gql`
  subscription ($hostname: String!) {
    deployNotificationReceived(hostname: $hostname)
  }
`;
